import React, { useState } from 'react';

import { observer } from 'mobx-react-lite';
import { FileAssociationType } from 'stores/file_association_store';
import useStores from 'hooks/useStores';



type FileAssociationContextType = {

    fetchListByAssociation: (identity: string, associated_type: string, associated_uuid: string) => Promise<FileAssociationType[]>;
    getListByAssociation: (associated_type: string, associated_uuid: string) => FileAssociationType[];
    associate: (identity: string, file: string, associated_type: string, associated_uuid: string) => Promise<FileAssociationType | null>;

    // Contains all known FileAssociation items
    items: FileAssociationType[];
}

export const FileAssociationContext = React.createContext<FileAssociationContextType>({

    // fetchFileAssociation: () => { throw 'Not Implemented' },
    // getFileAssociation: () => { throw 'Not Implemented' },
    // fetchListByIdentityFileAssociation: () => { throw 'Not Implemented' },
    // getListByIdentityFileAssociation: () => { throw 'Not Implemented' },
    fetchListByAssociation: () => { throw 'Not Implemented' },
    getListByAssociation: () => { throw 'Not Implemented' },
    associate: () => { throw 'Not Implemented' },
    items: [] as FileAssociationType[],
});




export const FileAssociationProvider = observer(({ children }: { children: React.ReactNode }) => {
    const [items, setItems] = useState([] as FileAssociationType[]);
    const { fileAssociationStore } = useStores();

    const [LOADED, setLOADED] = useState([] as string[]);



    // const addItems = (newItems: FileAssociationType[] | FileAssociationType) => {
    //     // Autogenerated
    //     newItems = Array.isArray(newItems) ? newItems : [newItems];
    //     setFileAssociation([...items, ...newItems]);
    // };

    // const fetchFileAssociation = async (uuid: string) => {
    //     // Autogenerated
    //     return fileAssociationStore.fetchFileAssociation(uuid);
    // };

    // const getFileAssociation = (uuid: string) => {
    //     // Autogenerated
    //     return items.find((item) => item.uuid === uuid) || null;
    // };

    // const fetchListByIdentity = async (identity_uuid: string) => {
    //     return fileAssociationStore.fetchListByIdentity(identity_uuid)
    //         .then(() => {
    //             setItems(fileAssociationStore.items);
    //             return getListByIdentity(identity_uuid);
    //         });
    // };

    // const getListByIdentity = (identity_uuid: string) => {
    //     return items.slice().filter((item) => item.identity === identity_uuid);
    // };


    const associate = async (identity: string,
        file: string,
        associated_type: string,
        associated_uuid: string): Promise<FileAssociationType | null> => {
        return fileAssociationStore.associate(identity, file, associated_type, associated_uuid)
            .then((association: FileAssociationType | null) => {
                setItems(fileAssociationStore.items);
                return association;
            });
    };

    const fetchListByAssociation = async (identity: string,
        associated_type: string,
        associated_uuid: string) => {
            if (LOADED.includes(associated_uuid)) {
                console.log(`Already loaded ${associated_uuid}`);
                return getListByAssociation(associated_type, associated_uuid);
            }
        return fileAssociationStore
            .fetchListByAssociation(identity, associated_type, associated_uuid)
            .then(() => {
                setItems(fileAssociationStore.items);
                setLOADED([...LOADED, associated_uuid]);
                return getListByAssociation(associated_type, associated_uuid);
            });
    };

    const getListByAssociation =  (associated_type: string, associated_uuid: string) => {
        return fileAssociationStore.items.filter((item: FileAssociationType) =>
            item.associated_type === associated_type &&
                item.associated_uuid === associated_uuid);
    };

    const data = {
        // fetchFileAssociation,
        // getFileAssociation,
        associate,
        fetchListByAssociation,
        getListByAssociation,
        items,
    };

    return (
        <FileAssociationContext.Provider value={data}>{ children }</FileAssociationContext.Provider>
    );

});
